import { createContext } from 'react';

import type { Permissions } from './registry';
import type { CurrentUser } from './types';

export interface PermissionContextValue {
  /** The signed-in user, or `null` when unauthenticated. */
  currentUser: CurrentUser | null;
  /**
   * Returns `true` when the current user may perform `action` on `resource`.
   * Pass `data` for resources whose grants depend on the instance (e.g. owner
   * checks). Resource + action are typed against the merged portal permissions.
   */
  hasPermission: <Resource extends keyof Permissions>(
    resource: Resource,
    action: Permissions[Resource]['action'],
    data?: Permissions[Resource]['dataType'],
  ) => boolean;
}

export const PermissionContext = createContext<PermissionContextValue | undefined>(undefined);
